
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 21.2C17.081 21.2 21.2 17.081 21.2 12C21.2 6.91898 17.081 2.8 12 2.8C6.91898 2.8 2.8 6.91898 2.8 12C2.8 17.081 6.91898 21.2 12 21.2ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 18.4291C11.4477 18.4291 11 17.9814 11 17.4291V10.8329C11 10.2806 11.4477 9.83286 12 9.83286C12.5523 9.83286 13 10.2806 13 10.8329V17.4291C13 17.9814 12.5523 18.4291 12 18.4291ZM13.0909 6.66183C13.0909 6.05934 12.6025 5.57092 12 5.57092C11.3975 5.57092 10.9091 6.05934 10.9091 6.66183V6.7491C10.9091 7.3516 11.3975 7.84001 12 7.84001C12.6025 7.84001 13.0909 7.3516 13.0909 6.7491V6.66183Z","fill":"#16171F"}})])
          )
        }
      }
    